<template>
  <div>
    <b-modal id="form-basic-salary" size="lg" no-close-on-backdrop>
      <validation-observer ref="formBasicSalary">
        <form>
          <horizontal-form-group label="Tahun Ke-">
            <validation-provider #default="{ errors }" name="year" rules="required">
              <b-form-input type="number" :disabled="isView" v-model="formPayload.years"></b-form-input>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </horizontal-form-group>

          <horizontal-form-group label="Level Band">
            <validation-provider #default="{ errors }" name="levelBand" rules="required">
              <v-select
                :disabled="isView"
                placeholder="-- Pilih --"
                :loading="loadingBand"
                :options="options"
                label="text"
                v-model="formPayload.levelBand"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </horizontal-form-group>

          <horizontal-form-group label="Nilai Gapok">
            <validation-provider #default="{ errors }" name="valueGapok" rules="required">
              <b-form-input :disabled="isView" v-model="formPayload.valueGapok" placeholder="Rp" type="number"></b-form-input>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </horizontal-form-group>
        </form>
      </validation-observer>

      <template #modal-footer="{}">
        <b-button v-if="!isView" class="d-flex" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" :disabled="loading" @click="submitItem()">
          <b-spinner small variant="light" class="mr-1" v-if="loading" /> Simpan
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import {
    BButton,
    BSpinner,
    BFormFile,
    BFormInput,
    BFormSelect
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";

import InputText from "@/components/InputText.vue";
import InputTextArea from "@/components/InputTextArea.vue";
import InputFile from "@/components/InputFile.vue";
import vSelect from "vue-select";
import { BandServices } from '../../services/band.service';
import { successNotification, errorNotification } from "@/auth/utils";
export default {
  data() {
    return {
      options: [],
      loadingBand: false,
      reqBand: {
        title: "",
        page: 1,
        size: 100000
      },
    }
  },
  components: {
    required,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    InputText,
    InputTextArea,
    InputFile,
    BFormFile,
    BFormInput,
    BFormSelect,
    vSelect
  },
  directives: {
    Ripple,
  },

  props: {
    pageTitle: {
      type: String,
    },
    formPayload: {
      type: "",
    },
    loading: {
      type: Boolean
    },
    editId: {
      type: Number,
    },
    isView: {
      type: Boolean,
    },
    createItem: {
      type: Function,
    },
    updateItem: {
      type: Function,
    }
  },
  methods: {
    GetBand() {
      this.loadingBand  = true;
      this.options = [];
      BandServices.findAll()
        .then((result) => {
          // window.console.log(result);
          this.loadingBand  = false;
          result.data.content.forEach((items) => {
             this.options.push({
               text: items.bandName,
               value: {...items}
             });
          });
        })
        .catch((e) => {
          this.loadingBand  = false;
          return errorNotification(this,"!Oops", e.message);
        });
    },
    submitItem() {
      this.$refs.formBasicSalary.validate()
        .then((result) => {
          if (result) {
            if (this.editId == null) {
              return this.createItem();
            }
            return this.updateItem();
          }
        });
    }
  },
  mounted() {
    this.GetBand();
  }
}
</script>

<style lang="scss">
  @import "@core/scss/vue/libs/vue-select.scss";
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
